module.exports = __webpack_public_path__ + "static/img/web_banner004.a1f3032.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/web_banner004.jpg
// module id = nQLn
// module chunks = 15